const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function getToken() {
  return localStorage.getItem('admin_token');
}

function headers(auth = false) {
  const h = { 'Content-Type': 'application/json' };
  if (auth) h['Authorization'] = `Bearer ${getToken()}`;
  return h;
}

async function handle(res) {
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const api = {
  // Auth
  login: (username, password) =>
    fetch(`${BASE}/api/auth/login`, { method: 'POST', headers: headers(), body: JSON.stringify({ username, password }) }).then(handle),
  getMe: () => fetch(`${BASE}/api/auth/me`, { headers: headers(true) }).then(handle),

  // Languages
  getLanguages: () => fetch(`${BASE}/api/languages`, { headers: headers() }).then(handle),
  updateLanguage: (code, data) =>
    fetch(`${BASE}/api/languages/${code}`, { method: 'PUT', headers: headers(true), body: JSON.stringify(data) }).then(handle),
  toggleLanguage: (code) =>
    fetch(`${BASE}/api/languages/${code}/toggle`, { method: 'PATCH', headers: headers(true) }).then(handle),

  // Streams
  getStreams: () => fetch(`${BASE}/api/streams`, { headers: headers() }).then(handle),
  getLiveStream: () => fetch(`${BASE}/api/streams/live`, { headers: headers() }).then(handle),
  createStream: (data) =>
    fetch(`${BASE}/api/streams`, { method: 'POST', headers: headers(true), body: JSON.stringify(data) }).then(handle),
  updateStream: (id, data) =>
    fetch(`${BASE}/api/streams/${id}`, { method: 'PUT', headers: headers(true), body: JSON.stringify(data) }).then(handle),
  toggleStream: (id) =>
    fetch(`${BASE}/api/streams/${id}/toggle`, { method: 'PATCH', headers: headers(true) }).then(handle),
  setLiveStream: (id) =>
    fetch(`${BASE}/api/streams/${id}/setlive`, { method: 'PATCH', headers: headers(true) }).then(handle),
  deleteStream: (id) =>
    fetch(`${BASE}/api/streams/${id}`, { method: 'DELETE', headers: headers(true) }).then(handle),

  // Admin users
  getAdminUsers: () => fetch(`${BASE}/api/admin-users`, { headers: headers(true) }).then(handle),
  createAdminUser: (data) =>
    fetch(`${BASE}/api/admin-users`, { method: 'POST', headers: headers(true), body: JSON.stringify(data) }).then(handle),
  updateAdminUser: (id, data) =>
    fetch(`${BASE}/api/admin-users/${id}`, { method: 'PUT', headers: headers(true), body: JSON.stringify(data) }).then(handle),
  deleteAdminUser: (id) =>
    fetch(`${BASE}/api/admin-users/${id}`, { method: 'DELETE', headers: headers(true) }).then(handle),

  // Visitors
  logVisit: (lang) =>
    fetch(`${BASE}/api/visitors`, { method: 'POST', headers: headers(), body: JSON.stringify({ lang }) }).then(handle),
  getStats: () => fetch(`${BASE}/api/visitors/stats`, { headers: headers(true) }).then(handle),

  // Audio tracks
  getAudioTracks: () => fetch(`${BASE}/api/audio`, { headers: headers(true) }).then(handle),
  uploadAudio: (code, file) => {
    const form = new FormData();
    form.append('audio', file);
    return fetch(`${BASE}/api/audio/upload/${code}`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getToken()}` },
      body: form,
    }).then(handle);
  },
  deleteAudio: (code) =>
    fetch(`${BASE}/api/audio/${code}`, { method: 'DELETE', headers: headers(true) }).then(handle),

  // Audio file URL
  audioUrl: (code) => `${BASE}/audio/${code}.mp3`,
  socketUrl: () => BASE,

  // Health
  health: () => fetch(`${BASE}/api/health`).then(handle),
};
